/* Salah on the Go — rotating collage.
 *
 * The "made to travel" collage stacks five photos, so only two are readable at a
 * time. Rather than flatten it into a grid (which lost the look the client wants),
 * keep the stack and CYCLE the photos through it: every few seconds one slot
 * crossfades to the next picture in the pool, so all of them get their turn.
 *
 * Deliberately gate-free: one timer that re-checks readiness on every tick. An
 * earlier version gated on "wait until an image has a src" and, because the photos
 * are lazy and far below the fold, that gate never opened and nothing ever rotated.
 */
(function () {
  'use strict';

  var POOL = [
    'sotg-wadirum-bag.jpg',
    'sotg-bag-interior.jpg',
    'sotg-rollup-train.jpg',
    'sotg-plane-pouch.jpg',
    'sotg-tote-keys.jpg',
    'sotg-window-passport.jpg',
    'sotg-carseat-bag.jpg',
  ];
  var EVERY = 3800;
  var FADE = 700;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var showing = null;
  var slotIdx = 0;
  var poolIdx = 0;
  var preloaded = false;

  function tick() {
    if (document.hidden) return;
    var wrap = document.querySelector('.dbtfy-stacked-with-image .wrap-images');
    if (!wrap) return;

    var slots = [].slice.call(wrap.querySelectorAll('.stack-image'));
    if (slots.length < 2) return;

    // only while the collage is actually on screen
    var r = wrap.getBoundingClientRect();
    if (r.bottom < 0 || r.top > (window.innerHeight || 0)) return;

    var probe = wrap.querySelector('img');
    var src = probe && (probe.currentSrc || probe.getAttribute('src'));
    if (!src || src.indexOf('/') === -1) return;      // not resolved yet — try again next tick
    var base = src.slice(0, src.lastIndexOf('/') + 1);
    var url = function (n) { return base + n + '?width=1200'; };

    if (!preloaded) {
      preloaded = true;
      POOL.forEach(function (n) { var i = new Image(); i.src = url(n); });
    }
    if (!showing) {
      showing = slots.map(function (_, i) { return i % POOL.length; });
      poolIdx = slots.length % POOL.length;
      slots.forEach(function (el) { el.style.transition = 'opacity ' + FADE + 'ms ease'; });
      return;                                          // first tick just sets up
    }

    // next picture that is not already on screen
    var guard = 0;
    while (showing.indexOf(poolIdx) !== -1 && guard++ < POOL.length) {
      poolIdx = (poolIdx + 1) % POOL.length;
    }
    var el = slots[slotIdx];
    var img = el.querySelector('img') || el;
    var pick = poolIdx;

    el.style.opacity = '0';
    setTimeout(function () {
      img.removeAttribute('srcset');   // srcset wins over src, so it has to go
      img.removeAttribute('sizes');
      img.setAttribute('src', url(POOL[pick]));
      showing[slotIdx] = pick;
      el.style.opacity = '1';
      slotIdx = (slotIdx + 1) % slots.length;
    }, FADE);

    poolIdx = (pick + 1) % POOL.length;
  }

  setInterval(tick, EVERY);
})();

/* The "Our story" hero now spans the full block, but the theme still advertises a
 * HALF-width `sizes` on that image, so the browser picks a ~670px source and it
 * renders soft at 1360px. Pin it to a large explicit source instead. */
(function () {
  'use strict';
  function sharpen() {
    var img = document.querySelector('[id$="sotg_our_story"] .image-with-text__media img');
    if (!img) return false;
    var src = img.currentSrc || img.getAttribute('src');
    if (!src || src.indexOf('/') === -1) return false;
    var base = src.split('?')[0];
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', base + '?width=2400');
    return true;
  }
  var tries = 0;
  var t = setInterval(function () {
    if (sharpen() || ++tries > 30) clearInterval(t);
  }, 400);
})();
